var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 253,
    viewBox: "0 0 525 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.948 0H0V186.015V199.087V201.645V214.474V217.762V252.959V253.041H406.753L409.272 250.524C447.835 211.997 486.438 173.43 525 134.904V0H490.948ZM522.521 35.9689C520.733 34.1826 518.945 32.3963 517.157 30.6101V43.4387L522.521 48.7975V51.3145L517.157 45.9557V59.0279L522.521 64.3867V133.686C483.553 172.618 444.584 211.551 405.615 250.483H265.995L260.55 245.043H247.465L252.91 250.483H250.391L244.946 245.043H232.105L237.55 250.483H234.828L229.383 245.043H216.298L221.743 250.483H219.224L213.779 245.043H200.938L206.384 250.483H64.5685L59.1235 245.043H46.0391L51.4841 250.483H48.9648L43.5197 245.043H30.6792L36.1242 250.483H32.8328L2.55998 220.238V216.95C4.34791 218.736 6.13584 220.522 7.92376 222.309V209.48L2.55998 204.121V201.604L7.92376 206.963V193.891L2.55998 188.532V31.4626L31.4919 2.51701H259.127L264.491 7.8758H277.575L272.212 2.51701H274.731L280.095 7.8758H292.935L287.572 2.51701H290.294L295.658 7.8758H308.742L303.379 2.51701H305.898L311.262 7.8758H324.102L318.738 2.51701H460.431L465.795 7.8758H478.88L473.516 2.51701H476.035L481.399 7.8758H494.24L488.876 2.51701H493.346L522.399 31.5438V36.0095L522.521 35.9689Z",
    fill: "#4083E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxL);
export default __webpack_public_path__ + "static/media/box_l.ce17639f3763a3e29ab2fe17d3d6926e.svg";
export { ForwardRef as ReactComponent };